<template>
  <div>
    <h3 v-if="showTitle" class="mb-2">Add Attachments</h3>
    <div class="row">
      <div class="col-12 mt-2 mb-2">
        <div class="input-belt mb-2" style="z-index: 9999;">
          <label>Attachments</label>
          <el-select
            v-model="selected"
            multiple
            collapse-tags
            placeholder="Choose Attachments"
          >
            <el-option-group
                v-for="(group, index) in docAttachmentDocuments"
                :key="index"
                :label="index"
            >
              <el-option
                v-for="docs in group.filter(doc => doc.uploaded)"
                :key="`${docs.id}-${Number(docs.is_app_document)}`"
                :label="`${docs.name} (${docs.filename})`"
                :value="`${docs.id}-${Number(docs.is_app_document)}`"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ "selectedData", "docDocuments", "showTitle"],
  data() {
    return {
      selected: this.selectedData
    };
  },
  methods: {

  },
  watch: {
    selected(newVal, oldVal) {
      this.$emit("update:selectedData", newVal);
    }
  },
  computed: {
    docAttachmentDocuments(){
      var thisDocAttachments = {};
      var docAttachments = {};

      this.docDocuments.forEach(item => {
        var cat = item.doc_category;
        if(cat == null || cat == 'fls') cat = 'customer';
          if(docAttachments[cat] === undefined)
            docAttachments[cat] = [];

          docAttachments[cat].push(item);
      });

      if(docAttachments.customer !== undefined) thisDocAttachments['CUSTOMER DOCUMENTS'] = docAttachments.customer;
      if(docAttachments.internal !== undefined) thisDocAttachments['INTERNAL DOCUMENTS'] = docAttachments.internal;
      if(docAttachments.bank !== undefined) thisDocAttachments['LENDER DOCUMENTS'] = docAttachments.bank;
      if(docAttachments.backend !== undefined) thisDocAttachments['UPLOADED DOCUMENTS'] = docAttachments.backend;
      if(docAttachments.seller !== undefined) thisDocAttachments['SELLER DOCUMENTS'] = docAttachments.seller;

      return thisDocAttachments;
    }
  }
};
</script>
